import { differenceInYears, addMonths, isBefore } from 'date-fns'

export const calculateAge = (birth_date: Date): number => {
  return differenceInYears(new Date(), birth_date)
}

export const isAdult = (birth_date: Date | undefined): boolean => {
  if (!birth_date) return false
  return calculateAge(birth_date) >= 18
}

export const canChangeBirthDate = (birth_date_changed_at: Date | undefined): boolean => {
  if (!birth_date_changed_at) return true

  const three_months_later = addMonths(birth_date_changed_at, 3)
  return isBefore(three_months_later, new Date())
}

export const getNextChangeDate = (birth_date_changed_at: Date | undefined): Date | null => {
  if (!birth_date_changed_at) return null
  return addMonths(birth_date_changed_at, 3)
}